import cx from "classnames";
import { ReactNode, useState } from "react";
import { RichText } from "../sections/RichText";
import styles from "./Collapsibles.module.css";
import { Icon } from "./Icon";

// Single item
export type CollapsibleProps = {
  title: string;
  text: string | ReactNode;
};
export const Collapsible = ({ title, text }: CollapsibleProps) => {
  const [isOpen, toggleOpen] = useState<boolean>(false);
  function handleClick() {
    toggleOpen(!isOpen);
  }
  return (
    <div className={styles.collapsible}>
      <div className={styles.itemTitle} onClick={handleClick}>
        <span>{title}</span>
        <Icon
          icon="chevron"
          rotate={isOpen ? 0 : 180}
          className={cx(styles.chevron)}
        />
      </div>
      <div className={cx(styles.itemText, { [styles.isOpen]: isOpen })}>
        <RichText text={text} />
      </div>
    </div>
  );
};

// list of items
export type CollapsiblesProps = {
  items: CollapsibleProps[];
};

export const Collapsibles = ({ items }: CollapsiblesProps) => {
  return (
    <div className={styles.collapsibles}>
      {items &&
        items.map((item, index) => <Collapsible key={item.title} {...item} />)}
    </div>
  );
};
